import { Badge, Col, Collapse, InputNumber, Radio, Row, Select, Slider } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { useState } from 'react';
import { DEFAULT_CONFIG_ELEMENT_IN_DOUBLE_COLUMNS } from '../../../constants';
import DoubleColumnConfigModal, { doubleColumnConfig } from './DoubleColumnConfigModal';
import { getMe } from '../../../store/idbHandler';
import { getMedantaBizId } from '../../../store/actions/app';
const { Panel } = Collapse;

const Layout: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
}> = ({ rxConfig, saveRxConfigInState }) => {
    const [showConfig, setShowConfig] = useState(false);

    const openConfig = () => {
        setShowConfig(true);
    };

    const closeConfig = () => {
        setShowConfig(false);
    };
    const bid = getMe()?.user['b-id'];
    const isMedanta = getMedantaBizId().includes(bid ?? '');
    const columnConfig =
        rxConfig?.columns_config && Object.keys(rxConfig?.columns_config).length > 0
            ? rxConfig?.columns_config
            : DEFAULT_CONFIG_ELEMENT_IN_DOUBLE_COLUMNS;

    return (
        <>
            <Badge.Ribbon text={<div>Introducing Space Saver Layout</div>} color="purple">
                <Collapse
                    expandIcon={() => (
                        <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-neutral-800">
                            <div className="w-full h-full flex items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                    className="w-14 h-15"
                                    fill="white"
                                >
                                    <path d="M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z" />
                                </svg>
                            </div>
                        </div>
                    )}
                >
                    <Panel header={<div className="font-700">Layout</div>} key="1">
                        <p className="mr-16 space-y-8">
                            <div className="space-y-4">
                                <span className="font-700">Element Separator</span>

                                <div className="flex justify-center">
                                    <Radio.Group
                                        value={rxConfig?.rx_element_key_seperator || '|'}
                                        size="middle"
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                rx_element_key_seperator: e.target.value,
                                            });
                                        }}
                                    >
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                            }}
                                            value="|"
                                        >
                                            |
                                        </Radio.Button>
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                            }}
                                            value=";"
                                        >
                                            ;
                                        </Radio.Button>
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                            }}
                                            value=","
                                        >
                                            ,
                                        </Radio.Button>
                                    </Radio.Group>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <span className="font-700">Style</span>
                                <div className="flex justify-center">
                                    <Radio.Group
                                        value={rxConfig?.template_column_type || 'single'}
                                        size="middle"
                                        onChange={(e) => {
                                            if (e.target.value === 'single') {
                                                saveRxConfigInState({
                                                    template_column_type: e.target.value,
                                                    columns_config: undefined,
                                                });
                                            } else {
                                                saveRxConfigInState({
                                                    template_column_type: e.target.value,
                                                });
                                            }
                                        }}
                                    >
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                            }}
                                            value="single"
                                        >
                                            Single column
                                        </Radio.Button>
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                            }}
                                            value="double"
                                        >
                                            <Badge
                                                count={'NEW'}
                                                color="blue"
                                                style={{
                                                    borderRadius: '2px',
                                                }}
                                                offset={[6, -6]}
                                            >
                                                Two column
                                            </Badge>
                                        </Radio.Button>
                                    </Radio.Group>
                                </div>
                            </div>
                            {rxConfig?.template_column_type === 'double' && (
                                <div className="space-y-4">
                                    <div className="flex justify-between">
                                        <span className="font-700">Two Column Config</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-16 w-16 fill-darwin-neutral-800 cursor-pointer"
                                            viewBox="0 0 512 512"
                                            onClick={openConfig}
                                        >
                                            <path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z" />
                                        </svg>
                                    </div>
                                    <div className="flex justify-center bg-darwin-neutral-100 rounded-4">
                                        <div className="w-full flex justify-between">
                                            <div className="w-full p-16 space-y-8 w-50p flex flex-col">
                                                {columnConfig?.left?.map((columnId) => {
                                                    return (
                                                        <div className="flex justify-center items-center font-700 py-8 px-20 flex-1 text-center border-dotted border text-darwin-neutral-800 rounded-4">
                                                            {doubleColumnConfig.find(
                                                                (column) => column.id === columnId,
                                                            )?.name || ''}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <div className="min-w-1 bg-darwin-neutral-500 00 h-full"></div>
                                            <div className="w-full p-16 space-y-8 w-50p flex flex-col">
                                                {columnConfig?.right?.map((columnId) => {
                                                    return (
                                                        <div className="flex justify-center items-center font-700 py-8 px-20 flex-1 text-center border-dotted border text-darwin-neutral-800 rounded-4">
                                                            {doubleColumnConfig.find(
                                                                (column) => column.id === columnId,
                                                            )?.name || ''}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="space-y-4">
                                <span className="font-700">Font size</span>

                                <div className="flex justify-center">
                                    <Radio.Group
                                        value={rxConfig?.prescription_size || 'normal'}
                                        size="middle"
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                prescription_size: e.target.value,
                                            });
                                        }}
                                    >
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                            }}
                                            value="compact"
                                        >
                                            {isMedanta ? 'Regular' : 'Small'}
                                        </Radio.Button>
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                            }}
                                            value="normal"
                                        >
                                            {isMedanta ? 'Large' : 'Medium'}
                                        </Radio.Button>
                                        {!isMedanta && (
                                            <Radio.Button
                                                style={{
                                                    paddingLeft: '16px',
                                                    paddingRight: '16px',
                                                }}
                                                value="spacious"
                                            >
                                                Large
                                            </Radio.Button>
                                        )}
                                        {!isMedanta && (
                                            <Radio.Button
                                                style={{
                                                    paddingLeft: '16px',
                                                    paddingRight: '16px',
                                                }}
                                                value="extra-large"
                                            >
                                                Extra Large
                                            </Radio.Button>
                                        )}
                                    </Radio.Group>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <span className="font-700">Space between Sections</span>

                                <div className="flex justify-center">
                                    <Radio.Group
                                        value={rxConfig?.spacing_between_sections || 'normal'}
                                        size="middle"
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                spacing_between_sections: e.target.value,
                                            });
                                        }}
                                    >
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '12px',
                                                paddingRight: '12px',
                                            }}
                                            value="compact"
                                        >
                                            Compact
                                        </Radio.Button>
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '12px',
                                                paddingRight: '12px',
                                            }}
                                            value="normal"
                                        >
                                            Normal
                                        </Radio.Button>
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '12px',
                                                paddingRight: '12px',
                                            }}
                                            value="spacious"
                                        >
                                            Spacious
                                        </Radio.Button>
                                        <Radio.Button
                                            style={{
                                                paddingLeft: '12px',
                                                paddingRight: '12px',
                                            }}
                                            value="extra-spacious"
                                        >
                                            Extra spacious
                                        </Radio.Button>
                                    </Radio.Group>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <span className="font-700">Page spacing (cm)</span>

                                <div className="ml-24">
                                    <div>
                                        <div>Left Margin :</div>{' '}
                                        <Row>
                                            <Col span={12}>
                                                <Slider
                                                    value={parseFloat(rxConfig?.margin_left || '')}
                                                    min={0}
                                                    max={100}
                                                    step={1}
                                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                    // @ts-ignore
                                                    railStyle={{
                                                        background: '#cccfdb',
                                                    }}
                                                    onChange={(value) => {
                                                        saveRxConfigInState({
                                                            margin_left: `${value}cm`,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <div className="flex items-center">
                                                <InputNumber
                                                    type={'number'}
                                                    min={0}
                                                    max={100}
                                                    style={{
                                                        margin: '0 16px',
                                                    }}
                                                    value={parseFloat(rxConfig?.margin_left || '')}
                                                    onChange={(value) => {
                                                        saveRxConfigInState({
                                                            margin_left: `${value}cm`,
                                                        });
                                                    }}
                                                />
                                                <div>cm</div>
                                            </div>
                                        </Row>
                                    </div>
                                    <div>
                                        <div>Right Margin :</div>{' '}
                                        <Row>
                                            <Col span={12}>
                                                <Slider
                                                    value={parseFloat(rxConfig?.margin_right || '')}
                                                    min={0}
                                                    max={100}
                                                    step={1}
                                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                    // @ts-ignore
                                                    railStyle={{
                                                        background: '#cccfdb',
                                                    }}
                                                    onChange={(value) => {
                                                        saveRxConfigInState({
                                                            margin_right: `${value}cm`,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <div className="flex items-center">
                                                <InputNumber
                                                    type={'number'}
                                                    min={0}
                                                    max={100}
                                                    style={{
                                                        margin: '0 16px',
                                                    }}
                                                    value={parseFloat(rxConfig?.margin_right || '')}
                                                    onChange={(value) => {
                                                        saveRxConfigInState({
                                                            margin_right: `${value}cm`,
                                                        });
                                                    }}
                                                />
                                                <div>cm</div>
                                            </div>
                                        </Row>
                                    </div>
                                    {rxConfig?.floating_header && (
                                        <div>
                                            <div>Top Margin :</div>{' '}
                                            <Row>
                                                <Col span={12}>
                                                    <Slider
                                                        value={parseFloat(
                                                            rxConfig?.floating_header_page_top_margin ||
                                                                '',
                                                        )}
                                                        min={0}
                                                        max={100}
                                                        step={1}
                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        railStyle={{
                                                            background: '#cccfdb',
                                                        }}
                                                        onChange={(value) => {
                                                            saveRxConfigInState({
                                                                floating_header_page_top_margin: `${value}cm`,
                                                            });
                                                        }}
                                                    />
                                                </Col>
                                                <div className="flex items-center">
                                                    <InputNumber
                                                        type={'number'}
                                                        min={0}
                                                        max={100}
                                                        style={{
                                                            margin: '0 16px',
                                                        }}
                                                        value={parseFloat(
                                                            rxConfig?.floating_header_page_top_margin ||
                                                                '',
                                                        )}
                                                        onChange={(value) => {
                                                            saveRxConfigInState({
                                                                floating_header_page_top_margin: `${value}cm`,
                                                            });
                                                        }}
                                                    />
                                                    <div>cm</div>
                                                </div>
                                            </Row>
                                        </div>
                                    )}

                                    {rxConfig?.floating_footer && (
                                        <div>
                                            <div>Bottom Margin :</div>{' '}
                                            <Row>
                                                <Col span={12}>
                                                    <Slider
                                                        value={parseFloat(
                                                            rxConfig?.floating_footer_page_bottom_margin ||
                                                                '',
                                                        )}
                                                        min={0}
                                                        max={100}
                                                        step={1}
                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        railStyle={{
                                                            background: '#cccfdb',
                                                        }}
                                                        onChange={(value) => {
                                                            saveRxConfigInState({
                                                                floating_footer_page_bottom_margin: `${value}cm`,
                                                            });
                                                        }}
                                                    />
                                                </Col>
                                                <div className="flex items-center">
                                                    <InputNumber
                                                        type={'number'}
                                                        min={0}
                                                        max={100}
                                                        style={{
                                                            margin: '0 16px',
                                                        }}
                                                        value={parseFloat(
                                                            rxConfig?.floating_footer_page_bottom_margin ||
                                                                '',
                                                        )}
                                                        onChange={(value) => {
                                                            saveRxConfigInState({
                                                                floating_footer_page_bottom_margin: `${value}cm`,
                                                            });
                                                        }}
                                                    />
                                                    <div>cm</div>
                                                </div>
                                            </Row>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </p>
                    </Panel>
                </Collapse>
            </Badge.Ribbon>

            {showConfig && (
                <DoubleColumnConfigModal
                    closeConfig={closeConfig}
                    rxConfig={rxConfig}
                    saveRxConfigInState={saveRxConfigInState}
                />
            )}
        </>
    );
};

export default Layout;
